import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
    Box, Typography, Grid, Container, Tabs, Tab,
    Card, CardContent, Button
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ServiceTable from '../components/ServiceTable';
import AnimatedSection from '../components/AnimatedSection';
import { useLocation } from 'react-router-dom';
import "@fontsource/playfair-display";

// Assets
const heroImg = '/assets/skin-hair-hero.jpeg';
const womenHeroImg = '/assets/closeup-shot-smart-creative-female-redhead-genius-biting-frame-glasses-squinting-curio.jpeg';
const menHeroImg = '/assets/men.jpeg';
const bridalBanner = '/assets/bridal_banner.jpeg';

// Data from WomenPage
const womenSections = [
    {
        title: 'Hair Cuts',
        rows: [
            { service: 'Fringe Cut', price: '₹500' },
            { service: 'Kids Hair Cut', price: '₹350' },
            { service: 'Advance Kids Hair Cut', price: '₹500' },
            { service: 'Hair Wash & Blow Dry', price: '₹1,000' },
            { service: 'Basic Haircut (U, V, Straight)', price: '₹800' },
            { service: 'Creative Hair Cut', price: '₹1,500' },
            { service: 'Advance Cut & Style', price: '₹2,000' },
        ],
    },
    {
        title: 'Hair Colours',
        rows: [
            { service: 'Half Highlights', price: '₹2,000' },
            { service: 'Root Touch Up', price: '₹2,000' },
            { service: 'Full Highlights', price: '₹4,000' },
            { service: 'Full Hair Colour', price: '₹5,000' },
            { service: 'Hair Streaks (per streak)', price: '₹700' },
        ],
    },
    {
        title: 'Straightening & Smoothening',
        rows: [
            { service: 'Fringe', price: '₹1,500' },
            { service: 'Up To Neck', price: '₹5,000' },
            { service: 'Shoulder Length', price: '₹6,000' },
            { service: 'Below Shoulder', price: '₹7,000' },
            { service: 'Extra Long', price: '₹10,000' },
        ],
    },
    {
        title: 'Ironing & Tongs',
        rows: [
            { service: 'Shoulder Length - Ironing', price: '₹1,000' },
            { service: 'Shoulder Length - Tongs', price: '₹1,500' },
            { service: 'Below Shoulder - Ironing', price: '₹800' },
            { service: 'Below Shoulder - Tongs', price: '₹1,000' },
            { service: 'Extra Long - Ironing', price: '₹2,000' },
            { service: 'Extra Long - Tongs', price: '₹3,000' },
        ],
    },
    {
        title: 'Keratin Treatments',
        rows: [
            { service: 'Up To Neck', price: '₹5,000' },
            { service: 'Shoulder Length', price: '₹7,000' },
            { service: 'Below Shoulder', price: '₹8,000' },
            { service: 'Extra Long', price: '₹10,000' },
        ],
    },
    {
        title: 'Hair Treatments',
        rows: [
            { service: 'Dandruff', price: '₹2,500' },
            { service: 'Hair Fall', price: '₹3,000' },
            { service: 'Loreal Aminexil', price: '₹2,500' },
            { service: 'Fibre Clinix', price: '₹2,500' },
            { service: 'Scalp Genesis', price: '₹3,000' },
            { service: 'Pro Longer', price: '₹3,000' },
            { service: 'Root Activating', price: '₹3,000' },
        ],
    },
    {
        title: 'Relax & Refresh',
        rows: [
            { service: 'Head Massage (20 Min)', price: '₹800' },
            { service: 'Foot Massage (20 Min)', price: '₹1,000' },
            { service: 'Shoulder & Back Massage (20 Min)', price: '₹1,500' },
        ],
    },
    {
        title: 'Full Body Massage',
        rows: [
            { service: '30 Min', price: '₹2,000' },
            { service: '45 Min', price: '₹3,000' },
            { service: '60 Min', price: '₹4,000' },
        ],
    },
    {
        title: 'Hair Spa',
        rows: [
            { service: 'Short Length - 30 Min', price: '₹1,000' },
            { service: 'Short Length - 60 Min', price: '₹1,500' },
            { service: 'Medium Length - 30 Min', price: '₹1,500' },
            { service: 'Medium Length - 60 Min', price: '₹2,000' },
            { service: 'Extra Length - 30 Min', price: '₹1,500' },
            { service: 'Extra Length - 60 Min', price: '₹2,000' },
        ],
    },
    {
        title: 'Clean Up',
        rows: [
            { service: 'Basic Clean Up', price: '₹800' },
            { service: 'Acne Clean Up', price: '₹1,000' },
            { service: 'Whitening Clean Up', price: '₹1,500' },
        ],
    },
    {
        title: 'Basic Facials',
        rows: [
            { service: 'Fruit Facial', price: '₹1,000' },
            { service: 'Chocolate Facial', price: '₹1,200' },
            { service: 'Tan Clear', price: '₹2,000' },
            { service: 'Brightup Facial', price: '₹2,300' },
            { service: 'Oxy Glow Facial', price: '₹2,500' },
            { service: 'Anti Ageing Facial', price: '₹2,800' },
            { service: 'Skin Miracle', price: '₹3,000' },
        ],
    },
    {
        title: 'Metallic Facials',
        rows: [
            { service: 'Pearl', price: '₹2,500' },
            { service: 'Gold', price: '₹3,000' },
            { service: 'Diamond', price: '₹3,500' },
            { service: '24K Carat Gold Facial', price: '₹4,000' },
        ],
    },
    {
        title: 'Luxury Facials',
        rows: [
            { service: 'Insta Fair', price: '₹3,000' },
            { service: 'Sensi Glow Facial', price: '₹3,000' },
            { service: 'Snow White', price: '₹3,500' },
            { service: 'Oxygen Facial', price: '₹3,500' },
            { service: 'Ultra Bright Facial', price: '₹3,500' },
            { service: 'Hydra Boost', price: '₹3,500' },
            { service: '4 Layer', price: '₹4,000' },
            { service: 'Fair For Sure Facial', price: '₹4,000' },
            { service: 'Party Facial', price: '₹4,000' },
            { service: 'O3 Facial', price: '₹5,000' },
            { service: 'Jewel Facial', price: '₹5,000' },
            { service: 'Bridal Glow Facial', price: '₹6,000' },
            { service: 'Splash Signature Facial', price: '₹8,000' },
        ],
    },
    {
        title: 'Pedicure',
        rows: [
            { service: 'Quick Pedicure', price: '₹700' },
            { service: 'Rose Pedicure', price: '₹800' },
            { service: 'Fruit Punch', price: '₹1,000' },
            { service: 'Chocolate Pedicure', price: '₹1,200' },
            { service: 'Foot Spa Pedicure', price: '₹1,500' },
            { service: 'Tata Tan Pedicure', price: '₹2,000' },
            { service: 'Crystal Pedicure', price: '₹2,500' },
            { service: 'Bomb Pedicure', price: '₹3,000' },
            { service: 'Peel Off Pedicure', price: '₹3,500' },
        ],
    },
    {
        title: 'Manicure',
        rows: [
            { service: 'Express Manicure', price: '₹600' },
            { service: 'Rose Manicure', price: '₹700' },
            { service: 'Fruit Manicure', price: '₹800' },
            { service: 'Chocolate Manicure', price: '₹1,000' },
            { service: 'Hand Spa Manicure', price: '₹1,200' },
            { service: 'Tata Tan Manicure', price: '₹1,500' },
            { service: 'Crystal Manicure', price: '₹2,000' },
            { service: 'Ice Cream Manicure', price: '₹3,500' },
            { service: 'Peel Off Manicure', price: '₹3,000' },
        ],
    },
    {
        title: 'Detans',
        rows: [
            { service: 'Face', price: '₹600' },
            { service: 'Face & Neck', price: '₹1,000' },
            { service: 'Face, Neck, Back', price: '₹1,500' },
            { service: 'Full Hands', price: '₹1,200' },
            { service: 'Half Hands', price: '₹600' },
            { service: 'Full Legs', price: '₹2,000' },
            { service: 'Half Legs', price: '₹1,000' },
            { service: 'Full Body', price: '₹4,000' },
        ],
    },
    {
        title: 'Waxing',
        rows: [
            { service: 'Eyebrow Wax', price: '₹200' },
            { service: 'Upper Lip', price: '₹200' },
            { service: 'Chin', price: '₹200' },
            { service: 'Fore Head', price: '₹200' },
            { service: 'Side Locks', price: '₹300' },
            { service: 'Full Face', price: '₹1,000' },
            { service: 'Under Arms', price: '₹300' },
            { service: 'Full Arms', price: '₹1,000' },
            { service: 'Half Arms', price: '₹600' },
            { service: 'Full Legs', price: '₹1,400' },
            { service: 'Half Legs', price: '₹800' },
            { service: 'Stomach', price: '₹1,000' },
            { service: 'Full Back', price: '₹1,500' },
            { service: 'Full Body', price: '₹6,000' },
            { service: 'Bikini', price: '₹4,000' },
        ],
    },
];

// Data from MenPage
const menSections = [
    {
        title: 'Hair Cuts',
        rows: [
            { service: 'Beard Shave', price: '₹200' },
            { service: 'Hair Wash & Blow Dry', price: '₹500' },
            { service: 'Kids Hair Style', price: '₹350' },
            { service: 'Senior Stylist', price: '₹300' },
            { service: 'Top Stylist', price: '₹500' },
            { service: 'Styling', price: '₹600' },
            { service: 'Creative Hair Cut', price: '₹600' },
        ],
    },
    {
        title: 'Hair Colours',
        rows: [
            { service: 'Mustache', price: '₹200' },
            { service: 'Streaks (per streak)', price: '₹300' },
            { service: 'Beard', price: '₹500' },
            { service: 'Highlights', price: '₹1,000 onwards' },
            { service: 'Root Touch Up', price: '₹1,000 onwards' },
            { service: 'Global Highlights', price: '₹2,000 onwards' },
            { service: 'Global Hair Colour', price: '₹2,000 onwards' },
        ],
    },
    {
        title: 'Straightening & Smoothening',
        rows: [
            { service: 'Straightening', price: '₹3,000 onwards' },
            { service: 'Smoothening', price: '₹3,500 onwards' },
        ],
    },
    {
        title: 'Hair Spa',
        rows: [
            { service: 'Short Length - 30 Min', price: '₹1,000' },
            { service: 'Short Length - 60 Min', price: '₹1,500' },
            { service: 'Medium Length - 30 Min', price: '₹1,500' },
            { service: 'Medium Length - 60 Min', price: '₹2,000' },
            { service: 'Extra Length - 30 Min', price: '₹1,500' },
            { service: 'Extra Length - 60 Min', price: '₹2,000' },
        ],
    },
    {
        title: 'Relax & Refresh',
        rows: [
            { service: 'Head Massage (20 Min)', price: '₹800' },
            { service: 'Foot Massage (20 Min)', price: '₹1,000' },
            { service: 'Shoulder & Back Massage (20 Min)', price: '₹1,500' },
        ],
    },
    {
        title: 'Full Body Massage',
        rows: [
            { service: '30 Min', price: '₹2,000' },
            { service: '45 Min', price: '₹3,000' },
            { service: '60 Min', price: '₹4,000' },
        ],
    },
    {
        title: 'Hair Treatments',
        rows: [
            { service: 'Dandruff', price: '₹2,500' },
            { service: 'Hair Fall', price: '₹3,000' },
            { service: 'Loreal Aminexil', price: '₹2,500' },
            { service: 'Fibre Clinix', price: '₹2,500' },
            { service: 'Scalp Genesis', price: '₹3,000' },
            { service: 'Pro Longer', price: '₹3,000' },
            { service: 'Root Activating', price: '₹3,500' },
        ],
    },
    {
        title: 'Waxing',
        rows: [
            { service: 'Fore Head', price: '₹100' },
            { service: 'Cheeks', price: '₹200' },
            { service: 'Under Arms', price: '₹500' },
            { service: 'Full Hands', price: '₹1,000' },
            { service: 'Full Front (chest)', price: '₹1,500' },
            { service: 'Full Legs', price: '₹1,500' },
            { service: 'Full Back', price: '₹2,000' },
            { service: 'Full Body', price: '₹5,000' },
        ],
    },
    {
        title: 'Keratin Treatments',
        rows: [
            { service: 'Keratin', price: '₹2,500 onwards' },
        ],
    },
    {
        title: 'Clean Up',
        rows: [
            { service: 'Basic Clean Up', price: '₹800' },
            { service: 'Acne Clean Up', price: '₹1,000' },
            { service: 'Whitening Clean Up', price: '₹1,500' },
        ],
    },
    {
        title: 'Basic Facials',
        rows: [
            { service: 'Fruit Facial', price: '₹1,000' },
            { service: 'Chocolate Facial', price: '₹1,200' },
            { service: 'Tan Clear', price: '₹2,000' },
            { service: 'Brightup Facial', price: '₹2,300' },
            { service: 'Oxy Glow Facial', price: '₹2,500' },
            { service: 'Anti Ageing Facial', price: '₹2,800' },
            { service: 'Skin Miracle', price: '₹3,000' },
        ],
    },
    {
        title: 'Metallic Facials',
        rows: [
            { service: 'Pearl', price: '₹2,500' },
            { service: 'Gold', price: '₹3,000' },
            { service: 'Diamond', price: '₹3,500' },
            { service: '24K Carat Gold Facial', price: '₹4,000' },
        ],
    },
    {
        title: 'Luxury Facials',
        rows: [
            { service: 'Insta Fair', price: '₹3,000' },
            { service: 'Sensi Glow Facial', price: '₹3,000' },
            { service: 'Snow White', price: '₹3,500' },
            { service: 'Oxygen Facial', price: '₹3,500' },
            { service: 'Ultra Bright Facial', price: '₹3,500' },
            { service: 'Hydra Boost', price: '₹3,500' },
            { service: '4 Layer', price: '₹4,000' },
            { service: 'Fair For Sure Facial', price: '₹4,000' },
            { service: 'Party Facial', price: '₹4,000' },
            { service: 'O3 Facial', price: '₹5,000' },
            { service: 'Jewel Facial', price: '₹5,000' },
            { service: 'Bridal Glow Facial', price: '₹6,000' },
            { service: 'Splash Signature Facial', price: '₹8,000' },
        ],
    },
    {
        title: 'Pedicure',
        rows: [
            { service: 'Quick Pedicure', price: '₹700' },
            { service: 'Rose Pedicure', price: '₹800' },
            { service: 'Fruit Punch', price: '₹1,000' },
            { service: 'Chocolate Pedicure', price: '₹1,200' },
            { service: 'Foot Spa Pedicure', price: '₹1,500' },
            { service: 'Tata Tan Pedicure', price: '₹2,000' },
            { service: 'Crystal Pedicure', price: '₹2,500' },
            { service: 'Bomb Pedicure', price: '₹3,000' },
            { service: 'Peel Off Pedicure', price: '₹3,500' },
        ],
    },
    {
        title: 'Manicure',
        rows: [
            { service: 'Express Manicure', price: '₹500' },
            { service: 'Rose Manicure', price: '₹600' },
            { service: 'Fruit Manicure', price: '₹800' },
            { service: 'Chocolate Manicure', price: '₹1,000' },
            { service: 'Hand Spa Manicure', price: '₹1,200' },
            { service: 'Tata Tan Manicure', price: '₹1,500' },
            { service: 'Crystal Manicure', price: '₹2,000' },
            { service: 'Ice Cream Manicure', price: '₹2,500' },
            { service: 'Peel Off Manicure', price: '₹3,000' },
        ],
    },
    {
        title: 'Treatment',
        rows: [
            { service: 'Heel Peel', price: '₹3,500' },
        ],
    },
];

const menPackages = [
    {
        name: 'Gold Package',
        price: '₹4,999',
        items: [
            '• Pearl Facial',
            '• Face & Neck De Tan',
            '• Glow Manicure',
            '• Regular Hair Spa',
            '• Hair Cut',
            '• Beard Shaping',
        ],
        featured: false,
    },
    {
        name: 'Premium Package',
        price: '₹6,999',
        items: [
            '• Far Nic Glow Facial',
            '• Face & Neck De Tan',
            '• Crystal Spa Pedicure',
            '• Crystal Spa Manicure',
            '• Full Body Crystal De Tan',
            '• Classic Hair Spa',
            '• Hair Cut',
            '• Beard Shaping',
        ],
        featured: true,
    },
    {
        name: 'Platinum Package',
        price: '₹8,999',
        items: [
            '• Signature Signature Facial',
            '• Face & Neck De Tan',
            '• Bomb Pedicure',
            '• Ice Cream Manicure',
            '• Full Body Crystal De Tan',
            '• Five Step Body Polishing',
            '• Conditioning Hair Spa',
            '• Hair Cut',
            '• Beard Shaving',
        ],
        featured: false,
    },
];

// Data from SkinHairPage
const skinHairSections = [
    {
        title: 'Stretch Marks Reduction',
        rows: [
            { service: 'Stretch Marks Reduction (Per Session)', price: '₹3,000' },
            { service: 'Stretch Marks Reduction (Package of 6)', price: '₹15,000' },
        ],
    },
    {
        title: 'Tattoo',
        rows: [
            { service: 'Small Tattoo', price: '₹500 onwards' },
            { service: 'Medium Tattoo', price: '₹2,000 onwards' },
            { service: 'Large Tattoo', price: '₹5,000 onwards' },
        ],
    },
    {
        title: 'Body Whitening Treatments',
        rows: [
            { service: 'Face Whitening', price: '₹2,500' },
            { service: 'Full Body Whitening', price: '₹8,000' },
            { service: 'Underarm Whitening', price: '₹1,500' },
            { service: 'Neck & Back Whitening', price: '₹3,000' },
        ],
    },
    {
        title: 'Piercing',
        rows: [
            { service: 'Ear Lobe', price: '₹500' },
            { service: 'Nose', price: '₹500' },
            { service: 'Cartilage', price: '₹800' },
            { service: 'Belly Button', price: '₹1,000' },
        ],
    },
    {
        title: 'Medical Facials',
        rows: [
            { service: 'Acne Treatment Facial', price: '₹3,000' },
            { service: 'Pigmentation Facial', price: '₹3,500' },
            { service: 'Anti-Ageing Medical Facial', price: '₹4,000' },
            { service: 'Skin Rejuvenation Facial', price: '₹5,000' },
            { service: 'Chemical Peel', price: '₹3,500' },
            { service: 'Micro Dermabrasion', price: '₹4,000' },
        ],
    },
    {
        title: 'Nail Extensions',
        rows: [
            { service: 'Basic Nail Extensions', price: '₹2,000' },
            { service: 'Gel Nail Extensions', price: '₹3,000' },
            { service: 'Acrylic Nail Extensions', price: '₹3,500' },
            { service: 'Nail Art (per nail)', price: '₹200' },
            { service: 'Nail Removal', price: '₹500' },
        ],
    },
    {
        title: 'Permanent Hair Removal',
        rows: [
            { service: 'Upper Lip (Per Session)', price: '₹1,500' },
            { service: 'Chin (Per Session)', price: '₹1,500' },
            { service: 'Full Face (Per Session)', price: '₹4,000' },
            { service: 'Under Arms (Per Session)', price: '₹3,000' },
            { service: 'Full Arms (Per Session)', price: '₹6,000' },
            { service: 'Full Legs (Per Session)', price: '₹8,000' },
            { service: 'Full Body (Per Session)', price: '₹15,000' },
            { service: 'Bikini (Per Session)', price: '₹5,000' },
        ],
    },
    {
        title: 'Fish Pedicure',
        rows: [
            { service: 'Fish Pedicure (30 Min)', price: '₹1,500' },
            { service: 'Fish Pedicure (60 Min)', price: '₹2,500' },
        ],
    },
];

// Data from BridalPage
const makeupPackages = [
    {
        name: 'Basic Make Up',
        price: '₹8,000',
        items: ['Make Up', 'Hair Do', 'Saree Draping'],
        featured: false,
    },
    {
        name: 'Premium Bridal',
        price: '₹10,000',
        items: ['Advanced Make Up', 'Hair Do', 'Saree Draping'],
        featured: true,
    },
];

const mehandiOptions = [
    { name: 'Full Hands', price: '₹2,000' },
    { name: 'Front & Back', price: '₹4,000' },
    { name: 'Full Hands (Arabic)', price: '₹1,000' },
];

const preBridalPackages = [
    {
        name: 'Gold Package',
        price: '₹10,000',
        items: [
            'Pure Pearl Facial',
            'Face & Neck Detan',
            'Spa Pedicure',
            'Spa Manicure',
            'Full Hands Waxing',
            'Half Leg Waxing',
            'Full Body Scrub',
            'Conditioning Hair Wash',
            'Threading',
        ],
        featured: false,
    },
    {
        name: 'Premium Package',
        price: '₹15,000',
        items: [
            'Ultra Bright Facial',
            'Face & Neck Detan',
            'Full Hands Waxing',
            'Full Legs Waxing',
            'Under Arms Waxing',
            'Crystal Pedicure',
            'Crystal Manicure',
            'Smoothening Hair Spa',
            'Conditioning Hair Wash',
            'Full Body Detan Polishing',
            'Threading',
        ],
        featured: true,
    },
    {
        name: 'Platinum Package',
        price: '₹20,000',
        items: [
            '24 Carat Gold Signature Facial',
            'Face & Neck Diamond Detan Pack',
            'Full Body Wax',
            'Bomb Pedicure',
            'Bomb Manicure',
            'Classic Hair Spa',
            'Hair Wash',
            '5 Step Body Polishing',
        ],
        featured: false,
    },
];

const sectionIds = ['bridal', 'women', 'men', 'skin-hair'];

export default function ServicesPage() {
    const [activeTab, setActiveTab] = useState(0);
    const location = useLocation();

    const scrollToSection = useCallback((index) => {
        const sectionId = sectionIds[index];
        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = 140;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    }, []);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        scrollToSection(newValue);
    };

    useEffect(() => {
        if (location.hash) {
            const hash = location.hash.replace('#', '');
            const hashIndex = sectionIds.indexOf(hash);
            if (hashIndex !== -1) {
                setActiveTab(hashIndex);
                setTimeout(() => scrollToSection(hashIndex), 120);
            }
        }
    }, [location.hash, scrollToSection]);

    return (
        <Box>
            <Helmet>
                <title>Hair, Skin & Bridal Services in Vizag | Splash Beauty Lounge</title>
                <meta name="description" content="Explore premium hair care, skin treatments, bridal makeup, weight loss and permanent hair removal services at Splash Beauty Lounge Vizag." />
                <meta name="keywords" content="hair treatments Vizag, skin treatments Vizag, bridal makeup services Vizag, facials Vizag, manicure pedicure Vizag, laser hair removal Vizag, salon packages Vizag, beauty services Asilmetta, salon services Vizag" />
            </Helmet>
            {/* Hero */}
            <Box
                sx={{
                    position: 'relative',
                    backgroundImage: `url(${heroImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    py: { xs: 10, md: 15 },
                    textAlign: 'center',
                    color: '#fff',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    },
                }}
            >
                <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            color: '#fff',
                            fontFamily: '"Playfair Display", serif',
                            fontSize: { xs: '2.5rem', md: '4rem' },
                            mb: 2,
                            textShadow: '0 2px 10px rgba(0,0,0,0.4)',
                        }}
                    >
                        Our Services
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: '"Lato", sans-serif',
                            color: 'rgba(255,255,255,0.9)',
                            fontSize: '1.2rem',
                            maxWidth: '700px',
                            mx: 'auto',
                            px: 2,
                        }}
                    >
                        Discover our comprehensive range of beauty and wellness treatments tailored for your unique needs.
                    </Typography>
                </Box>
            </Box>

            {/* Sticky Tabs */}
            <Box
                sx={{
                    position: 'sticky',
                    top: 80, // Matches exactly with Header height (80px)
                    zIndex: 1000,
                    backgroundColor: 'rgba(255, 255, 255, 0.98)',
                    backdropFilter: 'blur(10px)',
                    borderBottom: '1px solid #f0f0f0',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
                }}
            >
                <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{
                            minHeight: { xs: 50, sm: 60 },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#FF0099',
                                height: 3,
                                borderRadius: '3px 3px 0 0'
                            },
                            '& .MuiTabs-scrollButtons': {
                                color: '#FF0099',
                                '&.Mui-disabled': { opacity: 0.3 },
                                width: { xs: 30, sm: 40 }
                            },
                            '& .MuiTabs-flexContainer': {
                                justifyContent: { md: 'center' }
                            }
                        }}
                    >
                        {['BRIDAL', 'WOMEN', 'MEN', 'SKIN & HAIR'].map((label, index) => (
                            <Tab
                                key={label}
                                label={label}
                                sx={{
                                    fontFamily: '"Playfair Display", serif',
                                    fontWeight: 700,
                                    fontSize: {
                                        xs: '0.72rem', // Small mobile
                                        sm: '0.8rem',  // Medium mobile/tablet
                                        md: '0.9rem'   // Desktop
                                    },
                                    color: '#666',
                                    minWidth: { xs: '80px', sm: '120px', md: '160px' },
                                    px: { xs: 1, sm: 2 },
                                    py: { xs: 1.5, sm: 2 },
                                    letterSpacing: '0.05em',
                                    transition: 'all 0.3s ease',
                                    opacity: 0.7,
                                    '&.Mui-selected': {
                                        color: '#FF0099',
                                        opacity: 1,
                                        transform: 'scale(1.05)'
                                    },
                                    '&:hover': {
                                        color: '#FF0099',
                                        opacity: 1
                                    }
                                }}
                            />
                        ))}
                    </Tabs>
                </Container>
            </Box>

            {/* Bridal Section */}
            <Box id="bridal" sx={{ py: 8, backgroundColor: '#fff0f7' }}>
                <Container maxWidth="lg">
                    <AnimatedSection>
                        <Box
                            sx={{
                                position: 'relative',
                                height: '250px',
                                borderRadius: 4,
                                overflow: 'hidden',
                                mb: 6,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundImage: `url(${bridalBanner})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    inset: 0,
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }
                            }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    position: 'relative',
                                    color: '#fff',
                                    fontFamily: '"Playfair Display", serif',
                                    fontWeight: 700,
                                    zIndex: 1,
                                    fontSize: { xs: '2.2rem', md: '3rem' }
                                }}
                            >
                                Bridal Services
                            </Typography>
                        </Box>
                    </AnimatedSection>

                    {/* Makeup */}
                    <Box sx={{ mb: 8 }}>
                        <AnimatedSection>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: '"Playfair Display", serif',
                                    color: '#FF0099',
                                    textAlign: 'center',
                                    mb: 4,
                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                }}
                            >
                                Bridal Makeup
                            </Typography>
                        </AnimatedSection>
                        <Grid container spacing={3} justifyContent="center">
                            {makeupPackages.map((pkg, i) => (
                                <Grid item xs={12} sm={6} md={5} key={pkg.name}>
                                    <AnimatedSection delay={i * 0.15}>
                                        <Card
                                            elevation={pkg.featured ? 6 : 1}
                                            sx={{
                                                borderRadius: 3,
                                                border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                                                backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                                                textAlign: 'center',
                                                transition: 'transform 0.3s',
                                                '&:hover': { transform: 'translateY(-4px)' },
                                            }}
                                        >
                                            <CardContent sx={{ p: 4 }}>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Lato", sans-serif',
                                                        fontSize: '1rem',
                                                        fontWeight: 700,
                                                        color: pkg.featured ? '#fff' : '#1a1a1a',
                                                        mb: 1,
                                                    }}
                                                >
                                                    {pkg.name}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Playfair Display", serif',
                                                        fontSize: '2.2rem',
                                                        fontWeight: 800,
                                                        color: pkg.featured ? '#fff' : '#1a1a1a',
                                                        mb: 1.5,
                                                    }}
                                                >
                                                    {pkg.price}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Lato", sans-serif',
                                                        fontSize: '0.85rem',
                                                        color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#666',
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    {pkg.items.join(' • ')}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </AnimatedSection>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Mehandi */}
                    <Box sx={{ mb: 8 }}>
                        <AnimatedSection>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: '"Playfair Display", serif',
                                    color: '#FF0099',
                                    textAlign: 'center',
                                    mb: 4,
                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                }}
                            >
                                Mehandi
                            </Typography>
                        </AnimatedSection>
                        <Grid container spacing={3} justifyContent="center">
                            {mehandiOptions.map((opt, i) => (
                                <Grid item xs={12} sm={4} key={opt.name}>
                                    <AnimatedSection delay={i * 0.1}>
                                        <Box
                                            sx={{
                                                border: '1px solid #eee',
                                                borderRadius: 2,
                                                p: 3,
                                                textAlign: 'center',
                                                backgroundColor: '#fff',
                                                transition: 'box-shadow 0.3s',
                                                '&:hover': { boxShadow: '0 4px 15px rgba(255,0,153,0.1)' },
                                            }}
                                        >
                                            <Typography
                                                sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 600, fontSize: '0.95rem', color: '#333', mb: 1 }}
                                            >
                                                {opt.name}
                                            </Typography>
                                            <Typography
                                                sx={{ fontFamily: '"Playfair Display", serif', fontSize: '1.5rem', fontWeight: 700, color: '#FF0099' }}
                                            >
                                                {opt.price}
                                            </Typography>
                                        </Box>
                                    </AnimatedSection>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Pre-Bridal */}
                    <Box sx={{ mb: 5 }}>
                        <AnimatedSection>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: '"Playfair Display", serif',
                                    color: '#1a1a1a',
                                    textAlign: 'center',
                                    mb: 4,
                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                }}
                            >
                                Pre-Bridal Packages
                            </Typography>
                        </AnimatedSection>
                        <Grid container spacing={3} justifyContent="center">
                            {preBridalPackages.map((pkg, i) => (
                                <Grid item xs={12} sm={6} md={4} key={pkg.name}>
                                    <AnimatedSection delay={i * 0.12}>
                                        <Card
                                            elevation={pkg.featured ? 8 : 1}
                                            sx={{
                                                borderRadius: 3,
                                                border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                                                backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                                                height: '100%',
                                                transition: 'transform 0.3s',
                                                '&:hover': { transform: 'translateY(-4px)' },
                                            }}
                                        >
                                            <CardContent sx={{ p: 3 }}>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Lato", sans-serif',
                                                        fontSize: '1rem',
                                                        fontWeight: 700,
                                                        color: pkg.featured ? '#fff' : '#1a1a1a',
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    {pkg.name}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Playfair Display", serif',
                                                        fontSize: '1.8rem',
                                                        fontWeight: 800,
                                                        color: pkg.featured ? '#fff' : '#1a1a1a',
                                                        mb: 2,
                                                    }}
                                                >
                                                    {pkg.price}
                                                </Typography>
                                                {pkg.items.map((item, j) => (
                                                    <Typography
                                                        key={j}
                                                        sx={{
                                                            fontFamily: '"Lato", sans-serif',
                                                            fontSize: '0.82rem',
                                                            color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#555',
                                                            mb: 0.5,
                                                            lineHeight: 1.6,
                                                        }}
                                                    >
                                                        • {item}
                                                    </Typography>
                                                ))}
                                            </CardContent>
                                        </Card>
                                    </AnimatedSection>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    <AnimatedSection>
                        <Box sx={{ textAlign: 'center', pb: 4 }}>
                            <Button
                                component="a"
                                href="tel:8977626223"
                                variant="contained"
                                startIcon={<PhoneIcon />}
                                sx={{
                                    backgroundColor: '#FF0099',
                                    color: '#fff',
                                    borderRadius: '25px',
                                    px: 4,
                                    py: 1.3,
                                    fontSize: '0.95rem',
                                    fontWeight: 700,
                                    '&:hover': { backgroundColor: '#CC0077' },
                                    boxShadow: '0 4px 20px rgba(255,0,153,0.3)',
                                }}
                            >
                                Book Bridal Consultation
                            </Button>
                        </Box>
                    </AnimatedSection>
                </Container>
            </Box>

            {/* Women Section */}
            <Box id="women" sx={{ py: 8 }}>
                <Container maxWidth="lg">
                    <AnimatedSection>
                        <Box
                            sx={{
                                position: 'relative',
                                height: '200px',
                                borderRadius: 4,
                                overflow: 'hidden',
                                mb: 6,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundImage: `url(${womenHeroImg})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    inset: 0,
                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                }
                            }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    position: 'relative',
                                    color: '#fff',
                                    fontFamily: '"Playfair Display", serif',
                                    fontWeight: 700,
                                    zIndex: 1,
                                }}
                            >
                                Women's Menu
                            </Typography>
                        </Box>
                    </AnimatedSection>

                    <Grid container spacing={4}>
                        {womenSections.map((section, i) => (
                            <Grid item xs={12} md={6} key={section.title}>
                                <AnimatedSection delay={(i % 4) * 0.1}>
                                    <Box sx={{ mb: 1 }}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontFamily: '"Playfair Display", serif',
                                                color: '#1a1a1a',
                                                mb: 1.5,
                                                fontSize: '1.2rem',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {section.title}
                                        </Typography>
                                        <ServiceTable rows={section.rows} />
                                    </Box>
                                </AnimatedSection>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Men Section */}
            <Box id="men" sx={{ py: 8, backgroundColor: '#fdfdfd' }}>
                <Container maxWidth="lg">
                    <AnimatedSection>
                        <Box
                            sx={{
                                position: 'relative',
                                height: '200px',
                                borderRadius: 4,
                                overflow: 'hidden',
                                mb: 6,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundImage: `url(${menHeroImg})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    inset: 0,
                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                }
                            }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    position: 'relative',
                                    color: '#fff',
                                    fontFamily: '"Playfair Display", serif',
                                    fontWeight: 700,
                                    zIndex: 1,
                                }}
                            >
                                Men's Menu
                            </Typography>
                        </Box>
                    </AnimatedSection>

                    <Grid container spacing={4}>
                        {menSections.map((section, i) => (
                            <Grid item xs={12} md={6} key={section.title}>
                                <AnimatedSection delay={(i % 4) * 0.1}>
                                    <Box sx={{ mb: 1 }}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontFamily: '"Playfair Display", serif',
                                                color: '#FF0099',
                                                mb: 1.5,
                                                fontSize: '1.2rem',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {section.title}
                                        </Typography>
                                        <ServiceTable rows={section.rows} />
                                    </Box>
                                </AnimatedSection>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Men Packages */}
                    <Box sx={{ mt: 8 }}>
                        <AnimatedSection>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: '"Playfair Display", serif',
                                    color: '#1a1a1a',
                                    textAlign: 'center',
                                    mb: 5,
                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                }}
                            >
                                Men's Packages
                            </Typography>
                        </AnimatedSection>
                        <Grid container spacing={3} justifyContent="center">
                            {menPackages.map((pkg, i) => (
                                <Grid item xs={12} sm={6} md={4} key={pkg.name}>
                                    <AnimatedSection delay={i * 0.15}>
                                        <Card
                                            elevation={pkg.featured ? 8 : 1}
                                            sx={{
                                                borderRadius: 3,
                                                overflow: 'hidden',
                                                border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                                                backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                                                transition: 'transform 0.3s',
                                                height: '100%',
                                                '&:hover': { transform: 'translateY(-4px)' },
                                            }}
                                        >
                                            <CardContent sx={{ p: 3 }}>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Playfair Display", serif',
                                                        fontSize: '1.1rem',
                                                        fontWeight: 700,
                                                        color: pkg.featured ? '#fff' : '#1a1a1a',
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    {pkg.name}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: '"Playfair Display", serif',
                                                        fontSize: '2rem',
                                                        fontWeight: 800,
                                                        color: pkg.featured ? '#fff' : '#FF0099',
                                                        mb: 2,
                                                    }}
                                                >
                                                    {pkg.price}
                                                </Typography>
                                                {pkg.items.map((item, j) => (
                                                    <Typography
                                                        key={j}
                                                        sx={{
                                                            fontFamily: '"Lato", sans-serif',
                                                            fontSize: '0.82rem',
                                                            color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#555',
                                                            mb: 0.4,
                                                            lineHeight: 1.6,
                                                        }}
                                                    >
                                                        {item}
                                                    </Typography>
                                                ))}
                                            </CardContent>
                                        </Card>
                                    </AnimatedSection>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Container>
            </Box>

            {/* Skin & Hair Section */}
            <Box id="skin-hair" sx={{ py: 8 }}>
                <Container maxWidth="lg">
                    <AnimatedSection>
                        <Box
                            sx={{
                                position: 'relative',
                                height: '200px',
                                borderRadius: 4,
                                overflow: 'hidden',
                                mb: 6,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundImage: `url(${heroImg})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    inset: 0,
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }
                            }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    position: 'relative',
                                    color: '#fff',
                                    fontFamily: '"Playfair Display", serif',
                                    fontWeight: 700,
                                    zIndex: 1,
                                    textAlign: 'center',
                                    px: 2,
                                    fontSize: { xs: '1.8rem', md: '3rem' }
                                }}
                            >
                                Skin & Hair Treatments
                            </Typography>
                        </Box>
                    </AnimatedSection>

                    <Grid container spacing={4}>
                        {skinHairSections.map((section, i) => (
                            <Grid item xs={12} md={6} key={section.title}>
                                <AnimatedSection delay={(i % 4) * 0.1}>
                                    <Box sx={{ mb: 1 }}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontFamily: '"Playfair Display", serif',
                                                color: '#FF0099',
                                                mb: 1.5,
                                                fontSize: '1.2rem',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {section.title}
                                        </Typography>
                                        <ServiceTable rows={section.rows} />
                                    </Box>
                                </AnimatedSection>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
}